import { Navigate, useLocation } from "react-router-dom";
import { findRedirect } from "@/lib/redirects";

/**
 * Resolves any registered URL redirect at navigation time and rewrites the
 * URL with `replace` (no history entry). This is the SPA equivalent of a 301.
 * If no redirect matches, renders nothing and lets the normal router continue.
 */
const RedirectsHandler = () => {
  const location = useLocation();
  const target = findRedirect(location.pathname);
  if (target && target !== location.pathname) {
    return <Navigate to={`${target}${location.search}${location.hash}`} replace />;
  }
  return null;
};

export default RedirectsHandler;
